export { default } from './PrivilegeInput'



// WEBPACK FOOTER //
// ./src/App/components/PrivilegeInput/index.js